import AppLayout from '@cloudscape-design/components/app-layout'
import { Outlet } from 'react-router'
import SideNav from '@/components/shell/SideNav'
import TopNav from '@/components/shell/TopNav'
import NotificationBar from '@/components/common/NotificationBar'
import ErrorBoundary from '@/components/common/ErrorBoundary'
import HelpPanel from '@/components/shell/HelpPanel'

export default function PageLayout() {
  return (
    <>
      <TopNav />
      <AppLayout
        navigation={<SideNav />}
        navigationWidth={240}
        tools={<HelpPanel />}
        notifications={<NotificationBar />}
        content={
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        }
      />
    </>
  )
}
